import React from 'react';

// VIEWS
import Home from './components/Home/Home';
import About from './components/About/About';
import Klue from './components/Klue/Klue';
import GifMaker from './components/GifMaker/GifMaker';
import ExtensionDetector from './components/ExtensionDetector/ExtensionDetector';


// route config
const routes = [
  { path: '/',
    exact: true,
    component: Home
    
  },
  { path: '/gifmaker',
    exact: true,
    component: GifMaker
},
  { path: '/about',
    exact: true,
    component: About
},
  { path: '/klue',
    exact: true,
    component: Klue
}
];
export default routes;